export enum AccessLevel {
  None = 0,
  FullAccess = 1,
  ReadOnly = 2,
}
